<template>
  <section class="blog-page">
    <div v-if="error" class="blog-error">{{ error }}</div>
    <div v-else-if="loading" class="blog-loading">Loading…</div>
    <template v-else-if="post">
      <header class="blog-page-header">
        <router-link
          class="back-link"
          :to="{ name: 'topic', params: { slug: post.topic_slug } }"
        >
          ← {{ post.topic_title }}
        </router-link>
      </header>

      <BlogPostArticle :post="post" />
    </template>
  </section>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { BlogService } from "@/services/blog_service";
import BlogPostArticle from "@/components/blog/blog-post-article.vue";

const route = useRoute();
const blog = new BlogService();
const post = ref(null);
const loading = ref(true);
const error = ref("");

async function load() {
  loading.value = true;
  error.value = "";
  try {
    const pkg = await blog.getPost(route.params.slug);
    post.value = pkg.post;
  } catch (e) {
    error.value = "Post not found.";
    console.error(e);
  } finally {
    loading.value = false;
  }
}

onMounted(load);
watch(() => route.params.slug, load);
</script>

<style lang="scss" scoped>
@import "@/assets/styles/blog";
</style>
